module.exports = __webpack_public_path__ + "static/media/group4-mobile.b1b5dcac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/group4-mobile.svg
// module id = 1361
// module chunks = 0